import { render, staticRenderFns } from "./goldsilverWageProfit.vue?vue&type=template&id=4634f2ca&scoped=true&"
import script from "./goldsilverWageProfit.vue?vue&type=script&lang=js&"
export * from "./goldsilverWageProfit.vue?vue&type=script&lang=js&"
import style0 from "./goldsilverWageProfit.vue?vue&type=style&index=0&id=4634f2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4634f2ca",
  null
  
)

export default component.exports